/** @jsxImportSource @emotion/react */
import React, { Suspense } from 'react'
import css from '@emotion/css/macro'
import { Spin } from 'antd'
import colors from '@sportninja/common/constants/appColors'

import { PlayerProvider } from './context/PlayerContext'
import { UIProvider } from './context/UIContext'

const PlayerPage = React.lazy(() => import('./PlayerPage'))

interface NewPlayerProps {
  match: {
    params: {
      id: string
    }
  }
  isPublicRoute?: boolean
}

const LoadingFallback = () => (
  <div
    css={css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
      background-color: ${colors.SECONDARY_500};
    `}
  >
    <Spin size='large' />
  </div>
)

const NewPlayer = ({ match }: NewPlayerProps) => {
  const playerId = match.params.id

  return (
    <PlayerProvider playerId={playerId}>
      <UIProvider>
        <Suspense fallback={<LoadingFallback />}>
          <PlayerPage />
        </Suspense>
      </UIProvider>
    </PlayerProvider>
  )
}

export default NewPlayer
